module.exports = __webpack_public_path__ + "img/circle.302a4c9d.svg";